<div class="topic-slider">
  <h2 class="topic-slider__title" [tabIndex]="0">{{ topics.label }}</h2>

  <div class="topic-slider-wrapper">
    <div class="swiper__box" [class.full-width]="!homeBanner.show">
      <opac-swiper [configuration]="swiperConfiguration" [gradient]="false">
        <opac-swiper-item *ngFor="let topic of topics.firstLevel">
          <div class="topic-item" [matMenuTriggerFor]="topicMenu">
            <span (keydown.enter)="open(topic)" (keydown.space)="open(topic)" (click)="open(topic)" [tabIndex]="0">
              {{ topic.label }}
            </span>

            <opac-icon
              *ngIf="topic.nextLevel"
              icon="navigate_downward"
              (keydown.enter)="showSubtopics(topic)"
              (keydown.space)="showSubtopics(topic)"
              (click)="showSubtopics(topic)"
              [tabIndex]="0"
              [attr.aria-label]="('general.subtopicOf' | translate) + ' ' + topic.label"></opac-icon>
          </div>
        </opac-swiper-item>
      </opac-swiper>
    </div>

    <div class="topic-slider__banner" *ngIf="homeBanner.show">
      <img
        [src]="bannerImageUrl"
        [class.clickable]="homeBanner.targetUrl"
        (keydown.enter)="openBannerUrl()"
        [attr.aria-label]="
          !this.homeBanner.targetUrl
            ? ('general.banner' | translate)
            : ('general.goto' | translate) + ' ' + this.homeBanner.targetUrl
        "
        (keydown.space)="openBannerUrl()"
        (click)="openBannerUrl()"
        tabindex="0"
        alt="Banner image" />
    </div>
  </div>

  <div class="topic-slider__action">
    <button mat-flat-button routerLink="/topics" tabindex="0">{{ 'general.viewAll' | translate }}</button>
  </div>
</div>

<mat-menu #topicMenu="matMenu" class="topic-slider__menu">
  <button
    mat-menu-item
    *ngFor="let subtopic of subtopics"
    (keydown.enter)="open(subtopic)"
    (keydown.space)="open(subtopic)"
    (click)="open(subtopic)">
    {{ subtopic.label }}
  </button>
</mat-menu>
